import { render, staticRenderFns } from "./Girth.vue?vue&type=template&id=bc61d936&scoped=true&"
import script from "./Girth.vue?vue&type=script&lang=js&"
export * from "./Girth.vue?vue&type=script&lang=js&"
import style0 from "./Girth.vue?vue&type=style&index=0&id=bc61d936&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc61d936",
  null
  
)

export default component.exports